import { render, staticRenderFns } from "./InvestorPlanBanner.vue?vue&type=template&id=47000182&scoped=true&"
import script from "./InvestorPlanBanner.vue?vue&type=script&lang=js&"
export * from "./InvestorPlanBanner.vue?vue&type=script&lang=js&"
import style0 from "./InvestorPlanBanner.vue?vue&type=style&index=0&id=47000182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47000182",
  null
  
)

export default component.exports